<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { getNotificationsContext } from '@client/components/notifications';

  import { CampaignsService } from '@client/services/campaigns';
  import { TargetingService } from '@client/services/targeting';

  import { appStore } from '@client/stores/app';

  import { TargetingForm } from '../shared';

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const navigate = useNavigate();

  export let show = false;
  export let showPreviousModal = false;
  export let targetingData = {};

  let recipients = [];
  let domains = [];

  let targetingError = false;
  let targetingErrorMessage = '';

  let listFieldError = false;

  const onGoBack = () => {
    show = false;
    setTimeout(() => (showPreviousModal = true), 200);
  };

  const onCloseModal = () => {
    targetingData = {};
    recipients = [];
    domains = [];

    show = false;
  };

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onCloseModal();
    }
  };

  const onCreateCampaign = async () => {
    targetingError = false;

    $appStore.loading = true;

    const campaignData = {
      ...targetingData,
      paused: false
    };

    const campaignTargeting = [...recipients, ...domains];
    const activeTargeting = await TargetingService.get();

    campaignTargeting.forEach((name) => {
      const existingAccount = activeTargeting.accounts.find((account) => account.name === name);

      if (existingAccount) {
        const existingAd = existingAccount.ads.find(({ text }) => text === campaignData.rulename);

        if (!existingAd) {
          existingAccount.ads.push({
            text: campaignData.rulename
          });
        }
      } else {
        activeTargeting.accounts.push({
          name,
          ads: [
            {
              text: campaignData.rulename
            }
          ],
          tags: [],
          isNew: true
        });
      }
    });

    const targetingResponse = await TargetingService.update(activeTargeting);

    if (targetingResponse?.status >= 400) {
      notify(
        $format('label.FAILURE.CREATE', {
          values: { type: campaignData.rulename }
        }),
        'error'
      );

      targetingError = true;
      targetingErrorMessage = targetingResponse?.message;

      return;
    }

    const campaignResponse = await CampaignsService.createCampaign(campaignData);

    $appStore.loading = false;

    if (campaignResponse?.status >= 400) {
      notify($format('label.FAILURE.CREATE', { values: { type: campaignData.rulename } }), 'error');

      return;
    }

    setTimeout(() => (show = false), 200);

    notify($format('label.SUCCESS.CREATE', { values: { type: campaignData.rulename } }));

    navigate(`/marketing/campaigns/${campaignData.rulename}`);
  };

  $: isDisabled = listFieldError;
</script>

<Modal bind:isOpen={show} size="lg" fullscreen="lg">
  <ModalBody class="campaign-modal modal--content">
    <div class="modal-actions">
      <button class="back" on:click={onGoBack}>
        <Icon name="arrow-left" />
        <span>{$format('label.BACK')}</span>
      </button>

      <button class="close" on:click={onCloseModal}>
        <Icon name="x" />
      </button>
    </div>

    <div>
      <h1>{$format('label.TARGETING')}</h1>
      <p>{$format('label.DESCRIPTION.TARGETING_CAMPAIGN')}</p>
    </div>
    <div class="modal-body">
      <TargetingForm bind:recipients bind:domains bind:listFieldError />
    </div>
  </ModalBody>
  <ModalFooter>
    <Button id="modal-create-btn" color="primary" on:click={onCreateCampaign} disabled={isDisabled}>
      {$format('label.CREATE_CAMPAIGN')}
    </Button>
    <small>{targetingError ? targetingErrorMessage : ''}</small>
  </ModalFooter>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./targeting.scss"></style>
